/**
 * Shared homepage section-scroll utility.
 *
 * Rule: this function ONLY scrolls. It never navigates, never triggers the
 * PageTransitionLayer, never touches route/visibility state. Any caller that
 * is already on '/' must use this and nothing else for section navigation.
 */
export function scrollToHomeSection(sectionId: string) {
  const el = document.getElementById(sectionId);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  try {
    history.replaceState(null, '', `/#${sectionId}`);
  } catch {
    // ignore
  }
}